import { useSelector } from 'react-redux';

import { useReaderContext } from '../components/Reader/ReaderContext';
import { userType } from '../constants';
import type { StoreType } from '../reducers';
import { selectMindItem } from '../reducers/mindItems.selectors';
import { selectProduct } from '../reducers/products.selectors';
import { selectDocumentsPublishers } from '../reducers/publishers.selectors';
import { selectUser } from '../reducers/user.selectors';

export const eligibleUserTypes = [userType.document, userType.kombi, userType.aiOnly];

const useShouldShowAIAssistant = () => {
	const user = useSelector(selectUser);

	// Publisher access prevention
	const { mindItemId } = useReaderContext();
	const mindItem = useSelector((state: StoreType) => selectMindItem(state, mindItemId));
	const product = useSelector((state: StoreType) => selectProduct(state, mindItem?.product || ''));
	const publishers = useSelector(selectDocumentsPublishers);
	// Muki is enabled for all publishers unless explicitly disabled (isMukiAllowed === false)
	let isMukiAllowedPublisher = true;
	if (product?.publisher) {
		const publisherObj = publishers.find((publisher) => publisher.id === product.publisher);
		if (publisherObj && publisherObj.isMukiAllowed === false) {
			isMukiAllowedPublisher = false;
		}
	}

	if (mindItemId && !isMukiAllowedPublisher) {
		return false;
	}

	// MUKI blocking applies only to school users
	// Non-school users are not restricted by isMukiBlocked
	// isMukiBlocked will be set to false also for all B2B trial users (LMID 24, 241 and 242)
	if (user?.isSchoolUser && user?.isMukiBlocked) {
		return false;
	}

	// Check if user has eligible type and is not a library user
	const hasEligibleUserType = Boolean(user?.type && eligibleUserTypes.includes(user.type));
	const isNotLibraryUser = !user?.isLibraryUser;

	return hasEligibleUserType && isNotLibraryUser;
};

export default useShouldShowAIAssistant;
